// Data for the footer including information in different languages
const footerData = {
  czech: {
    email: "Email",
    phone: "Telefon",
    createdBy: "Vytvořil",
    website: "Vaše Webová Stránka",
    rightsReserved: "Všechna práva vyhrazena.",
    year: "2024",
    locationLabel: "Umístění",
    location: "Česká republika Praha",
  },
  english: {
    email: "Email",
    phone: "Phone",
    createdBy: "Created by",
    website: "Your Website",
    rightsReserved: "All rights reserved.",
    year: "2024",
    locationLabel: "Location",
    location: "Czech Republic Prague",
  },
  spanish: {
    email: "Correo electrónico",
    phone: "Teléfono",
    createdBy: "Creado por",
    website: "Su sitio web",
    rightsReserved: "Todos los derechos reservados.",
    year: "2024",
    locationLabel: "Ubicación",
    location: "República Checa Praga",
  },
  french: {
    email: "Email",
    phone: "Téléphone",
    createdBy: "Créé par",
    website: "Votre site web",
    rightsReserved: "Tous droits réservés.",
    year: "2024",
    locationLabel: "Emplacement",
    location: "République tchèque Prague",
  },
};

export default footerData;
